/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_End_DateInputs */

const en_resume_editor_end_date = /** @type {(inputs: Resume_Editor_End_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End Date`)
};

const de_resume_editor_end_date = /** @type {(inputs: Resume_Editor_End_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enddatum`)
};

const fr_resume_editor_end_date = /** @type {(inputs: Resume_Editor_End_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date de fin`)
};

const es_resume_editor_end_date = /** @type {(inputs: Resume_Editor_End_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de fin`)
};

const it_resume_editor_end_date = /** @type {(inputs: Resume_Editor_End_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data di fine`)
};

const nl_resume_editor_end_date = /** @type {(inputs: Resume_Editor_End_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einddatum`)
};

const pl_resume_editor_end_date = /** @type {(inputs: Resume_Editor_End_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data zakonczenia`)
};

const fi_resume_editor_end_date = /** @type {(inputs: Resume_Editor_End_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Päättymispäivä`)
};

const da_resume_editor_end_date = /** @type {(inputs: Resume_Editor_End_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slutdato`)
};

const sv_resume_editor_end_date = /** @type {(inputs: Resume_Editor_End_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slutdatum`)
};

/**
* | output |
* | --- |
* | "End Date" |
*
* @param {Resume_Editor_End_DateInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_end_date = /** @type {((inputs?: Resume_Editor_End_DateInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_End_DateInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_end_date(inputs)
	if (locale === "fr") return fr_resume_editor_end_date(inputs)
	if (locale === "es") return es_resume_editor_end_date(inputs)
	if (locale === "it") return it_resume_editor_end_date(inputs)
	if (locale === "nl") return nl_resume_editor_end_date(inputs)
	if (locale === "pl") return pl_resume_editor_end_date(inputs)
	if (locale === "fi") return fi_resume_editor_end_date(inputs)
	if (locale === "da") return da_resume_editor_end_date(inputs)
	if (locale === "sv") return sv_resume_editor_end_date(inputs)
	return en_resume_editor_end_date(inputs)
});